// Sub-nav do Catálogo: alterna entre Produtos SaaS e Planos externos.
// Renderizado no header de cada página de Catálogo.

import { Boxes, Layers } from 'lucide-react';
import { NavLink } from 'react-router-dom';

import { cn } from '@control-center/ui';

interface Tab {
  to: string;
  label: string;
  icon: typeof Boxes;
}

const tabs: Tab[] = [
  { to: '/catalog/products', label: 'Produtos SaaS', icon: Boxes },
  { to: '/catalog/plans', label: 'Planos externos', icon: Layers },
];

export function CatalogTabs(): JSX.Element {
  return (
    <nav aria-label="Catálogo" className="flex items-center gap-1 border-b border-line pb-px">
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          className={({ isActive }) =>
            cn(
              'flex items-center gap-2 px-3 py-2 text-[13px] font-medium transition-colors',
              'border-b-2 -mb-px',
              isActive ? 'border-ink text-ink' : 'border-transparent text-muted hover:text-ink-2',
            )
          }
        >
          <tab.icon size={14} strokeWidth={1.8} />
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
